module.exports = __webpack_public_path__ + "static/img/prq7.e29ba7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq7.jpg
// module id = 888v
// module chunks = 2